import type { ReactNode } from 'react';
import { Box, Stack, Typography, alpha } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

interface LockedOverlayProps {
  children: ReactNode;
  message?: string;
}

export const LockedOverlay = ({ children, message = 'This feature is locked' }: LockedOverlayProps) => {
  return (
    <Box sx={{ position: 'relative', minHeight: '100vh' }}>
      <Box
        sx={{
          filter: 'blur(4px)',
          pointerEvents: 'none',
          userSelect: 'none',
        }}
        aria-hidden
      >
        {children}
      </Box>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: alpha('#000', 0.25),
          backdropFilter: 'blur(2px)',
          zIndex: (theme) => theme.zIndex.appBar - 1,
          pointerEvents: 'none',
        }}
      >
        <Stack
          alignItems="center"
          spacing={2}
          sx={{
            px: 4,
            py: 5,
            borderRadius: 3,
            backgroundColor: alpha('#0b1020', 0.6),
            border: `1px solid ${alpha('#fff', 0.12)}`,
            backdropFilter: 'blur(8px)',
            pointerEvents: 'auto',
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: alpha('#2970FF', 0.18),
              color: '#2970FF',
            }}
          >
            <LockIcon sx={{ fontSize: 38 }} />
          </Box>
          <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: '1.05rem' }}>
            {message}
          </Typography>
          <Typography sx={{ color: alpha('#fff', 0.6), fontSize: '0.85rem', textAlign: 'center', maxWidth: 320 }}>
            Upgrade your plan to unlock this tool.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default LockedOverlay;
